import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { sendClick } from 'reaxl-analytics';
import { Button, Glyphicon, LinkIcon } from 'reaxl';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function OwnerWebsiteCTA(_ref) {
  let {
    bsStyle = 'primary',
    className,
    hideIcon = false,
    href = '',
    label,
    analyticsData,
    onClick = () => {},
    uiContext = 'default',
    target = '_blank',
    ...rest
  } = _ref;
  if (!href) return null;
  const handleClick = event => {
    event.stopPropagation();
    sendClick('ownerWebsite', event, analyticsData);
    if (onClick()) {
      event.preventDefault();
    }
  };
  const handleRightClick = event => {
    event.stopPropagation();
    sendClick('ownerWebsite', event, analyticsData);
  };
  const buttonProps = {
    target,
    rel: 'nofollow noopener',
    href,
    bsStyle,
    onClick: handleClick,
    onContextMenu: handleRightClick,
    className: clsx({
      'padding-0': bsStyle === 'link'
    }, className),
    'data-cmp': 'ownerWebsiteCTA',
    ...rest
  };
  const glyph = 'offsite';
  const glyphClassName = 'margin-left-1';
  const buttonLabel = label || 'Visit Dealer Website';
  if (uiContext === 'link') {
    return /*#__PURE__*/_jsx(LinkIcon, {
      ...buttonProps,
      partner: true,
      placement: "after",
      undecorated: true,
      children: buttonLabel
    });
  }
  if (uiContext === 'unstyledLink') {
    return /*#__PURE__*/_jsx(LinkIcon, {
      ...buttonProps,
      className: "link-unstyled",
      placement: "after",
      undecorated: true,
      children: buttonLabel
    });
  }
  return /*#__PURE__*/_jsxs(Button, {
    ...buttonProps,
    block: uiContext === 'block',
    children: [buttonLabel, !hideIcon && /*#__PURE__*/_jsx(Glyphicon, {
      className: glyphClassName,
      glyph: glyph,
      "aria-hidden": "true"
    })]
  });
}
export default OwnerWebsiteCTA;